import {
    IRoundingRulesSettings,
    IAutoBreakSettings,
    IAutoTransferSettings,
    IPositionSelectionSettings,
    ICaliforniaOvertimeRule,
    IPayGroupSettings,
    IPunchRulesSettings,
    IHierarchyItem,
    IPunchQuestion,
    IBreak,
    IJobDocument,
    IScheduleBudgetUnitsSettings,
    IOTPolicySettings,
    IRuleProperty
} from "../../../../models"

export interface IHierarchyItemSettings {
    RoundingRulesSettings?: IRoundingRulesSettings
    AutoBreakSettings?: IAutoBreakSettings
    AutoTransferSettings?: IAutoTransferSettings
    PositionSelectionSettings?: IPositionSelectionSettings
    CaliforniaOvertimeRule?: ICaliforniaOvertimeRule
    PayGroupSettings?: IPayGroupSettings
    PunchRulesSettings?: IPunchRulesSettings
    ApprovedIPAddresses?: string[]
    ApprovedIVRPhoneNumbers?: string[]
    PunchQuestion?: IPunchQuestion
    MobileBreaks?: IBreak[]
    ScheduleBudgetUnitsSettings?: IScheduleBudgetUnitsSettings
    OTPolicySettings?: IOTPolicySettings
    // if we need to add a new setting, let's add it to below interface too
}

export interface IInheritedHierarchySettingsItems {
    RoundingRulesSettings: IHierarchyItem | IJobDocument
    AutoBreakSettings: IHierarchyItem | IJobDocument
    AutoTransferSettings: IHierarchyItem | IJobDocument
    PositionSelectionSettings: IHierarchyItem | IJobDocument
    CaliforniaOvertimeRule: IHierarchyItem | IJobDocument
    PayGroupSettings: IHierarchyItem | IJobDocument
    PunchRulesSettings: IHierarchyItem | IJobDocument
    ApprovedIPAddresses: IHierarchyItem | IJobDocument
    PunchQuestion: IHierarchyItem | IJobDocument
    MobileBreaks: IHierarchyItem | IJobDocument
    ScheduleBudgetUnitsSettings: IHierarchyItem | IJobDocument
    OTPolicySettings: IHierarchyItem | IJobDocument
    ApprovedIVRPhoneNumbers: IHierarchyItem | IJobDocument
}

export let InitInheritedHierarchySettingsItems: IInheritedHierarchySettingsItems = {
    RoundingRulesSettings: null,
    AutoBreakSettings: null,
    AutoTransferSettings: null,
    PositionSelectionSettings: null,
    CaliforniaOvertimeRule: null,
    PayGroupSettings: null,
    PunchRulesSettings: null,
    ApprovedIPAddresses: null,
    PunchQuestion: null,
    MobileBreaks: null,
    ScheduleBudgetUnitsSettings: null,
    OTPolicySettings: null,
    ApprovedIVRPhoneNumbers: null,
}